
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MarketingBrand } from '~/interfaces/user.interface';

@Component
export default class BrandConsent extends Vue {
    @Prop() brand!: MarketingBrand;
    @Prop() consent!: boolean;
}
